import { render, staticRenderFns } from "./PopUpConfirmarRechazar.vue?vue&type=template&id=68185e7f"
import script from "./PopUpConfirmarRechazar.vue?vue&type=script&lang=js"
export * from "./PopUpConfirmarRechazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports